import { createSlice } from '@reduxjs/toolkit';
import { getSonographers } from '../../../rtk-apis/users/getSonographers';

type Sonographer = {
  _id: string;
  name?: string;
  email?: string;
  role?: string;
  hospitalId?: string;
  clinicName?: string;
};

const initialState = {
  status: '',
  data: [] as Sonographer[],
  msg: '',
  loading: false,
};

const getSonographersSlice = createSlice({
  name: 'getSonographersSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = [];
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getSonographers.pending, state => {
        state.loading = true;
      })
      .addCase(getSonographers.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data || [];
        state.msg = action?.payload?.msg;
      })
      .addCase(getSonographers.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = [];
        state.msg = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearState } = getSonographersSlice.actions;
export default getSonographersSlice.reducer;
